function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "icon",
  transform: "translate(7.071 7.072)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1303",
  "data-name": "Path 1303",
  d: "M101.243,289.271,76.918,264.946l24.325-24.325,24.317,24.325,24.325,24.325,24.325-24.325-24.325-24.325-20.035,19.658",
  transform: "translate(-76.918 -240.621)",
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 10
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_1",
  "data-name": "Line 1",
  x1: 23.717,
  y1: 23.717,
  transform: "translate(12.761 12.982)",
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 10
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_6",
  "data-name": "Ellipse 6",
  cx: 4.928,
  cy: 4.928,
  r: 4.928,
  transform: "translate(43.26 0.275)",
  fill: "#02ffe9"
}));

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 111.434,
    height: 62.792,
    viewBox: "0 0 111.434 62.792",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e1f59a58.svg";
export { ForwardRef as ReactComponent };